// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__i7UBm","onlyAction":"styles_onlyAction__gbhIQ"};